import { render, staticRenderFns } from "./OurImpact.vue?vue&type=template&id=d1dd97f2&"
import script from "./OurImpact.vue?vue&type=script&lang=js&"
export * from "./OurImpact.vue?vue&type=script&lang=js&"
import style0 from "./OurImpact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports